import {
  CHECK_AVAILABLE_USER_NAME,
  GENERATE_TRADE_IMAGE_PATH,
  GET_AUTO_UPLOAD_STATUS_PATH,
  LAST_ACCOUNT_UPDATE_PATH,
  PROFILE_PATH,
  REFRESH_ACCOUNT_DATA_PATH,
  REGISTER_PATH,
  RESTORE_PASSWORD_PATH,
  USER_ACCOUNTS_PATH,
} from '../constants'
import { ForgotPasswordFormData } from '../pages/ForgotPassword/schema'
import { SignupFormData } from '../pages/Signup/schema'
import AbstractService from '../services/AbstractService'
import { ServerResponse } from '../types'

import {
  AutoUploadStatusEnum,
  CheckUserNameData,
  LastAccountDataUpdate,
  ResetPasswordData,
  User,
  UserAccount,
  UserPlatform,
} from './types'

class UserServiceClass extends AbstractService {
  getUserProfile = () => this.request<ServerResponse<User>>(PROFILE_PATH, 'get', true, null)

  getUserAccounts = () =>
    this.request<ServerResponse<UserAccount[]>>(USER_ACCOUNTS_PATH, 'get', true, null)

  registerUserProfile = (
    data: Omit<SignupFormData, 'country'> & {
      country: string
      registrationPlatform: UserPlatform
    },
  ) => this.request<ServerResponse<User>>(REGISTER_PATH, 'post', true, data)

  resetPassword = ({ email }: ForgotPasswordFormData) =>
    this.request<ServerResponse<never>>(
      RESTORE_PASSWORD_PATH + `?email=${email}`,
      'get',
      true,
      null,
    )

  changePassword = (data: ResetPasswordData) =>
    this.request<ServerResponse<never>>(RESTORE_PASSWORD_PATH, 'post', true, data)

  checkUserNameAvailable = (userName: string) =>
    this.request<ServerResponse<CheckUserNameData>>(
      `${CHECK_AVAILABLE_USER_NAME}/${userName}`,
      'get',
    )

  fetchLastAccountDate = (accountId: number) =>
    this.request<ServerResponse<LastAccountDataUpdate>>(
      `${LAST_ACCOUNT_UPDATE_PATH}/${accountId}`,
      'get',
    )

  refreshAccountData = (accountId: number) =>
    this.request<ServerResponse<never>>(`${REFRESH_ACCOUNT_DATA_PATH}/${accountId}`, 'get')

  generateSharedImage = (data: { tradeId: number }) =>
    this.request<ServerResponse<{ image: string; extension: string }>>(
      GENERATE_TRADE_IMAGE_PATH,
      'post',
      true,
      data,
    )

  getAutoUploadStatus = (accountId: number) =>
    this.request<ServerResponse<{ status: AutoUploadStatusEnum }>>(
      `${GET_AUTO_UPLOAD_STATUS_PATH}/${accountId}`,
      'get',
    )

  checkAuthStatus = () =>
    this.request<ServerResponse<{ logged_in: boolean; name?: string }>>(
      '/auth/status',
      'get',
      false,
      null,
    )
}

export const UserService = new UserServiceClass()
